import script from "./FindBox.vue?vue&type=script&setup=true&lang=js"
export * from "./FindBox.vue?vue&type=script&setup=true&lang=js"

import "./FindBox.vue?vue&type=style&index=0&id=1be9e20d&scoped=true&lang=css"
/* custom blocks */
import block0 from "./FindBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/tml/work/WP-plugins/wpaprsdb/wpaprsdb/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be9e20d"]])

export default __exports__